export const scenarios = {
  dev: [''], // lets keep it empty on prod
  mock: ['Mocks'],
  theme: ['Theme'],
  init: ['Initial'],
  signature: ['SignDocument', 'SignatureOtp'],
  videoId: [
    'GeneralConditions',
    'UserData',
    'SignDocument',
    'DocumentType',
    'PlaceOfBirth',
    'VideoOnboarding',
    'VideoId',
  ],
  videoIdForStandardSignature: [
    'GeneralConditions',
    'UserData',
    'DocumentType',
    'PlaceOfBirth',
    'VideoOnboarding',
    'VideoIdForStandardSignature',
    'VideoVerifying',
  ],
  'videoId/eidv.videoTest': ['UserData', 'DocumentType', 'VideoOnboarding', 'VideoId'],
  'videoId/smartnow.test': ['UserData', 'DocumentType', 'VideoOnboarding', 'VideoId'],
  'videoId/payment.authorization': [
    'GeneralConditionsBeforeBankSelection',
    'BankSelection',
    'UserData',
    'DocumentType',
    'VideoOnboarding',
    'VideoId',
  ],
  'videoId/signicat.video.micropayment': [
    'GeneralConditionsBeforeBankSelection',
    'BankSelection',
    'UserData',
    'DocumentType',
    'VideoOnboarding',
    'VideoId',
  ],
  'videoId/signicat.addressVerification.test': [
    'MicropaymentInfoWithVideoIdIkano',
    'MicropaymentFintecIkano',
    'CompleteIkano',
  ],
  'videoId/signicat.qes.micropayment': [
    'GeneralConditionsWithMicropaymentIkano',
    'SignDocument',
    'UserData',
    'DocumentType',
    'VideoId',
  ],
  'videoId/signicat.eid.idin.videoId': ['UserData', 'DocumentType', 'VideoId'],

  // Ikano Scenarios Start
  'videoId/ikano.de.videoid': ['SignDocumentIkano', 'UserData', 'DocumentType', 'VideoId', 'Otp'],
  'videoId/ikano.de': ['SignDocumentIkano', 'UserData', 'DocumentType', 'VideoId'],
  'videoId/ikano.de.fleks': ['SignDocumentIkano', 'UserData', 'DocumentType', 'VideoId'],
  'videoId/ikano.de.openBanking.2': ['SignDocumentIkano', 'UserData', 'DocumentType', 'VideoId'],
  'videoId/ikano.de.openBanking.2.mock': [
    'SignDocumentIkano',
    'UserData',
    'DocumentType',
    'VideoId',
  ],
  'videoId/ikano.de.goToMobile': ['SignDocumentIkano', 'UserData', 'DocumentType', 'VideoId'],
  'videoId/ikano.de.goToMobile.mock': ['SignDocumentIkano', 'UserData', 'DocumentType', 'VideoId'],
  'videoId/ikano.de.addressVerification': [
    'MicropaymentInfoWithVideoIdIkano',
    'MicropaymentFintecIkano',
    'CompleteIkano',
  ],
  'videoId/ikano.addressVerification.test': [
    'MicropaymentInfoWithVideoIdIkano',
    'MicropaymentFintecIkano',
    'CompleteIkano',
  ],
  'micropayment/ikano.de': [
    'MicropaymentInfoWithVideoIdIkano',
    'AccountHolderMock',
    'MicropaymentFintecIkano',
    'CompleteIkano',
  ],
  'micropayment/ikano.de.fleks': [
    'MicropaymentInfoWithVideoIdIkano',
    'AccountHolderMock',
    'MicropaymentFintecIkano',
    'CompleteIkano',
  ],
  'micropayment/ikano.de.reversed': [
    'MicropaymentReversedInfoWithVideoIdIkano',
    'AccountHolderMock',
    'MicropaymentFintecIkano',
    'CompleteIkano',
  ],
  'micropayment/ikano.de.openBanking1': [
    'MicropaymentInfoIkanoOpenBanking',
    'AccountHolderMock',
    'MicropaymentFintecIkano',
    'CompleteIkano',
  ],
  'micropayment/ikano.de.openBanking.1': [
    'MicropaymentInfoIkanoOpenBanking',
    'AccountHolderMock',
    'MicropaymentFintecIkano',
    'CompleteIkano',
  ],
  'micropayment/ikano.de.b': [
    'MicropaymentFintecIkano',
    'AccountHolderMock',
    'UserData',
    'SignDocumentIkano',
    'DocumentType',
    'VideoId',
  ],
  'micropayment/ikano.addressVerification.test': [
    'MicropaymentInfoWithVideoIdIkano',
    'AccountHolderMock',
    'MicropaymentFintecIkano',
    'CompleteIkano',
  ],
  'address-verification/ikano.de': ['AddressUploadIkano'],
  'address-verification/ikano.de.fleks': ['AddressUploadIkano'],
  'terms-and-conditions/ikano.de': ['TermsAndConditionsWithMicropaymentIkano'],
  'terms-and-conditions/ikano.de.openBanking1': [
    'TermsAndConditionsMicropaymentInfoIkanoOpenBanking',
  ],
  'terms-and-conditions/ikano.de.openBanking.1': [
    'TermsAndConditionsMicropaymentInfoIkanoOpenBanking',
  ],
  'terms-and-conditions/ikano.de.openBanking.2': ['TermsAndConditionsWithMicropaymentIkano'],
  'terms-and-conditions/ikano.de.IFL': ['TermsAndConditionsWithMicropaymentIkano'],
  'terms-and-conditions/ikano.de.IFL.openBanking.1': [
    'TermsAndConditionsMicropaymentInfoIkanoOpenBanking',
  ],
  'terms-and-conditions/ikano.de.IFL.openBanking.2': ['TermsAndConditionsWithMicropaymentIkano'],
  'terms-and-conditions/ikano.de.IBL': ['TermsAndConditionsWithMicropaymentIkano'],
  'terms-and-conditions/ikano.de.IBL.openBanking.1': [
    'TermsAndConditionsMicropaymentInfoIkanoOpenBanking',
  ],
  'terms-and-conditions/ikano.de.IBL.openBanking.2': ['TermsAndConditionsWithMicropaymentIkano'],
  'terms-and-conditions/ikano.de.fleks': ['TermsAndConditionsWithMicropaymentIkano'],
  'terms-and-conditions/ikano.de.reversed': ['TermsAndConditionsWithMicropaymentIkano'],
  // Ikano Scenarios End

  // Santander Scenarios Start
  'videoId/santander.it': [
    'GeneralConditions',
    'UserData',
    'SignDocumentSantander',
    'DocumentType',
    'VideoOnboarding',
    'VideoId',
  ],
  'verifying/santander.es.forJoint.2': ['IdentityVerification'],
  'verified-santander': ['VerifiedSantander'],
  'videoId/santander.it.forJoint': [
    'GeneralConditions',
    'UserData',
    'SignDocumentSantander',
    'DocumentType',
    'VideoOnboarding',
    'VideoId',
  ],
  // Santander Scenarios End
  'videoId/merchantEnrolment.poc.eidv': [
    'GeneralConditions',
    'UserData',
    'DocumentType',
    'VideoOnboarding',
    'VideoId',
  ],
  'videoId/onventis.eidv.single': [
    'GeneralConditions',
    'UserData',
    'SignDocumentOnventis',
    'DocumentType',
    'VideoOnboarding',
    'VideoId',
  ],
  'videoId/eidv.video.withConsents': [
    'GeneralConditions',
    'UserData',
    'DocumentType',
    'VideoOnboarding',
    'VideoId',
  ],
  'videoId/claude.eidv.qes.no-terms': [
    'UserData',
    'SignDocument',
    'DocumentType',
    'VideoOnboarding',
    'VideoId',
  ],
  'videoId/claude.eidv.aes.no-terms': [
    'UserData',
    'SignDocument',
    'DocumentType',
    'VideoOnboarding',
    'VideoId',
  ],
  micropayment: ['MicropaymentInfo', 'AccountHolderMock', 'MicropaymentFintec'],
  'micropayment-fintec': ['MicropaymentInfo', 'AccountHolderMock', 'MicropaymentFintec'],
  'micropayment/fintec': ['MicropaymentInfoAmex', 'AccountHolderMock', 'MicropaymentFintecAmex'],

  'micropayment/signicat.qes.micropayment': [
    'MicropaymentInfoWithVideoIdIkano',
    'AccountHolderMock',
    'MicropaymentFintec',
  ],
  'micropayment/signicat.addressVerification.test': [
    'MicropaymentInfoWithVideoId',
    'AccountHolderMock',
    'MicropaymentFintecIkano',
    'CompleteIkano',
  ],
  'address-verification': ['AddressUploadIkano'],
  'address-verification/merchantEnrolment.poc.addressVerification': ['AddressUploadIkano'],
  // Amex Scenarios Start
  // Amex card application overrides: the same pages as the default scenario of each flow
  // (address-verification, readid, eid, videoId, wallet-verification), restyled for Amex.
  // amex.great - continues after the NFC / EUDI wallet identity verification
  'address-verification/amex.great': ['AddressUploadAmexGreat'],
  // amex-great-demo.* - Amex card application demo
  'readid/amex-great-demo.readid': ['ReadIdAmexGreat'],
  'readid-completed/amex-great-demo.readid': ['ReadIdCompletedAmexGreat'],
  'readid/amex-great-demo.readid+address': ['ReadIdAmexGreat'],
  'readid-completed/amex-great-demo.readid+address': ['ReadIdCompletedAmexGreat'],
  'address-verification/amex-great-demo.readid+address': ['AddressUploadAmexGreat'],
  'eid/amex-great-demo.nbid+address': ['EidAmexGreat'],
  'address-verification/amex-great-demo.nbid+address': ['AddressUploadAmexGreat'],
  'eid/amex-great-demo.sbid+address': ['EidAmexGreat'],
  'address-verification/amex-great-demo.sbid+address': ['AddressUploadAmexGreat'],
  'videoId/amex-great-demo.videoId+address': [
    'UserDataAmexGreat',
    'DocumentTypeAmexGreat',
    'VideoOnboardingAmexGreat',
    'VideoIdAmexGreat',
  ],
  'address-verification/amex-great-demo.videoId+address': ['AddressUploadAmexGreat'],
  'videoId/amex-great-demo.videoId': [
    'UserDataAmexGreat',
    'DocumentTypeAmexGreat',
    'VideoOnboardingAmexGreat',
    'VideoIdAmexGreat',
  ],
  'videoId/amex-great-demo.qes+address': [
    'GeneralConditionsAmexGreat',
    'UserDataAmexGreat',
    'SignDocumentAmexGreat',
    'DocumentTypeAmexGreat',
    'PlaceOfBirthAmexGreat',
    'VideoOnboardingAmexGreat',
    'VideoIdAmexGreat',
  ],
  'address-verification/amex-great-demo.qes+address': ['AddressUploadAmexGreat'],
  'videoId/amex-great-demo.qes': [
    'GeneralConditionsAmexGreat',
    'UserDataAmexGreat',
    'SignDocumentAmexGreat',
    'DocumentTypeAmexGreat',
    'PlaceOfBirthAmexGreat',
    'VideoOnboardingAmexGreat',
    'VideoIdAmexGreat',
  ],
  'wallet-verification/amex-great-demo.wallet+address': ['WalletVerificationAmexGreat'],
  'address-verification/amex-great-demo.wallet+address': ['AddressUploadAmexGreat'],
  'wallet-verification/amex-great-demo.wallet': ['WalletVerificationAmexGreat'],
  // Amex Scenarios End
  'utility-bill-address-verification': ['AddressUploadIkano'],
  'residence-permit-address-verification': [
    'AddressVerificationTwoSidedIkano',
    'AddressUploadBothSidesIkano',
  ],
  kontomatik: [
    'IntroKontomatik',
    'KontomatikPage',
    'ProgressPageKontomatik',
    'AddressUploadPageKontomatik',
  ],
  pooling: ['Progress'],
  'switch-to-mobile': ['SwitchToMobile'],
  'continue-on-mobile': ['ContinueOnMobile'],
  'incorrect-pin-code': ['IncorrectPinCode'],
  'thank-you-mobile': ['GoToMobileThankYou'],
  'device-switched': ['DeviceSwitched'],
  'continue-on-computer': ['ContinueOnComputer'],
  resume: ['ResumeFromEmail'],
  error: ['Error'],
  'dtp.openBankingLogin/waiting': ['DTPWaiting'],
  'dtp.openBankingLogin.waiting/waiting': ['DTPWaiting'],
  waiting: ['DTPWaiting'],
  verifying: ['Verifying'],
  'waiting-till-end': ['WaitingAfterGoToMobile'],
  progress: ['Progress'],
  'waiting-progress': ['Progress'],
  'eid-retry': ['BankIdRetry'],
  'terms-and-conditions': ['TermsAndConditions'],
  'terms-and-conditions/dtp.openBankingLogin': ['TermsAndConditionsDTPInfo'],
  'videoId/demo.msteams.videoId': [
    'GeneralConditions',
    'UserData',
    'DocumentType',
    'VideoOnboarding',
    'VideoId',
  ],
  'videoId/demo.google.videoId': [
    'GeneralConditions',
    'UserData',
    'DocumentType',
    'VideoOnboarding',
    'VideoId',
  ],
  'salt-edge': ['Saltedge'],
  'salt-edge-return': ['SaltedgeReturn'],
  // Data collection scenarios - heat and pv
  'data-collection': ['DataCollection'],
  'switch-to-mobile/enpal.affordability-check.heat': ['SwitchToMobileWithHowto'],
  'switch-to-mobile/enpal.affordability-check.no-banking-screen.heat': ['SwitchToMobileWithHowto'],
  'switch-to-mobile/enpal.affordability-check.primary.heat': ['SwitchToMobileWithHowto'],
  'switch-to-mobile/enpal.affordability-check.secondary.heat': ['SwitchToMobileWithHowto'],
  'switch-to-mobile/enpal.pv.ses.withAffordabilityCheck.forJoint': ['SwitchToMobileWithHowto'],
  'switch-to-mobile/enpal.affordability-check.secondary.retrofit.forJoint': [
    'SwitchToMobileWithHowto',
  ],
  'switch-to-mobile/enpal.affordability-check.primary.retrofit.forJoint': [
    'SwitchToMobileWithHowto',
  ],
  'switch-to-mobile/enpal.affordability-check.retrofit': ['SwitchToMobileWithHowto'],
  'switch-to-mobile/enpal.affordability-check.clarify': ['SwitchToMobileWithHowto'],
  'switch-to-mobile/enpal.affordability-check.primary.clarify.forJoint': [
    'SwitchToMobileWithHowto',
  ],
  'switch-to-mobile/enpal.affordability-check.secondary.clarify.forJoint': [
    'SwitchToMobileWithHowto',
  ],
  'switch-to-mobile/enpal.affordability-check.clarify.evidenceMandatory': [
    'SwitchToMobileWithHowto',
  ],
  'switch-to-mobile/enpal.affordability-check.primary.clarify.evidenceMandatory.forJoint': [
    'SwitchToMobileWithHowto',
  ],
  'switch-to-mobile/enpal.affordability-check.secondary.clarify.evidenceMandatory.forJoint': [
    'SwitchToMobileWithHowto',
  ],
  'switch-to-mobile/enpal.pv.ses.withJointAffordabilityCheck.primary.forJoint': [
    'SwitchToMobileWithHowto',
  ],
  'switch-to-mobile/enpal.pv.ses.withJointAffordabilityCheck.secondary.forJoint': [
    'SwitchToMobileWithHowto',
  ],
  'switch-to-mobile/enpal.affordability-check.primary.heat.forJoint': ['SwitchToMobileWithHowto'],
  'switch-to-mobile/enpal.affordability-check.secondary.heat.forJoint': ['SwitchToMobileWithHowto'],
  gocardless: ['GocardlessCheck', 'Country', 'GocardlessBankSelection'],
  'gocardless-sandbox-select': [
    'GocardlessCheck',
    'GocardlessTransactionDataSelection',
    'GocardlessCustomTransactionData',
    'Country',
    'GocardlessBankSelection',
  ],
  'gocardless-return': ['GocardlessProcessing'],
  'gocardless-income-confirmation': ['GocardlessIncomeConfirmation'],
  eid: ['Eid'],
  'error-ios-browser-not-supported': ['ErrorIosBrowserNotSupported'],
  'mastercard-openbanking': ['OpenbankingMastercard'],
  'videoId/eidv.test': [
    'GeneralConditions',
    'UserData',
    'SignDocument',
    'DocumentType',
    'VideoOnboarding',
    'VideoId',
  ],
  onfido: ['Onfido'],
  'signing-select-method': ['EidMethodSelection'],
  'signing-waiting': ['SigningWaiting'],
  'videoId/docuSign.demo': [
    'SignDocument',
    'DocumentType',
    'PlaceOfBirth',
    'VideoOnboarding',
    'VideoId',
  ],
  'micropayment/docuSign.demo': [
    'MicropaymentInfoDocusign',
    'AccountHolderMock',
    'MicropaymentFintec',
  ],
  success: ['Success'],
  // Enpal Scenarios
  welcome: ['WelcomeEnpal'],
  verified: ['SuccessEnpal'],
  'verified-ses': ['SuccessSesEnpal'],
  // Enpal Enrollment Scenarios
  'verified-ltqc-enrollment': ['EnrollmentVerified'],
  // Enpal Countersign Scenarios
  'videoId/eidv.ltqcSign.test': ['LtqcSignDocument', 'LtqcSign'],
  'videoId/enpal.de.ltqcSign': ['LtqcSignDocument', 'LtqcSign'],
  // Enpal Single Scenarios
  // enpal.de.single
  'videoId/enpal.de.single': [
    'GeneralConditions',
    'UserData',
    'SignDocumentEnpal',
    'DocumentTypeEnpal',
    'VideoOnboarding',
    'VideoIdEnpal',
  ],
  'video-id-retry/enpal.de.single': ['VideoIdEnpal'],
  'switch-to-mobile/enpal.de.single': ['SwitchToMobileEnpal'],
  'verifying/enpal.de.single': ['IdentityVerificationEnpal'],
  // enpal.de.ses.simple
  'videoId/enpal.de.ses.simple': [
    'GeneralConditions',
    'UserData',
    'SignDocumentEnpal',
    'DocumentTypeEnpal',
    'VideoOnboarding',
    'VideoIdEnpal',
  ],
  'video-id-retry/enpal.de.ses.simple': ['VideoIdEnpal'],
  'switch-to-mobile/enpal.de.ses.simple': ['SwitchToMobileEnpal'],
  'verifying/enpal.de.ses.simple': ['IdentityVerificationEnpal'],
  // enpal.pv.ses.withCounterSigning.forJoint
  'videoId/enpal.pv.ses.withCounterSigning.forJoint': [
    'GeneralConditions',
    'UserData',
    'SignDocumentEnpal',
    'DocumentTypeEnpal',
    'VideoOnboarding',
    'VideoIdEnpal',
  ],
  'video-id-retry/enpal.pv.ses.withCounterSigning.forJoint': ['VideoIdEnpal'],
  'switch-to-mobile/enpal.pv.ses.withCounterSigning.forJoint': ['SwitchToMobileEnpal'],
  'verifying/enpal.pv.ses.withCounterSigning.forJoint': ['IdentityVerificationEnpal'],
  // enpal.pv.ses.forJoint
  'videoId/enpal.pv.ses.forJoint': [
    'GeneralConditions',
    'UserData',
    'SignDocumentEnpal',
    'DocumentTypeEnpal',
    'VideoOnboarding',
    'VideoIdEnpal',
  ],
  'video-id-retry/enpal.pv.ses.forJoint': ['VideoIdEnpal'],
  'switch-to-mobile/enpal.pv.ses.forJoint': ['SwitchToMobileEnpal'],
  'verifying/enpal.pv.ses.forJoint': ['IdentityVerificationEnpal'],
  // enpal.pv.qes.forJoint
  'videoId/enpal.pv.qes.forJoint': [
    'GeneralConditions',
    'UserData',
    'SignDocumentEnpal',
    'DocumentTypeEnpal',
    'VideoOnboarding',
    'VideoIdEnpal',
  ],
  'switch-to-mobile/enpal.pv.qes.forJoint': ['SwitchToMobileEnpal'],
  'verifying/enpal.pv.qes.forJoint': ['IdentityVerificationEnpal'],
  // enpal.partnersales.qes.forJoint
  'videoId/enpal.partnersales.qes.forJoint': [
    'GeneralConditions',
    'UserData',
    'SignDocumentEnpal',
    'DocumentTypeEnpal',
    'VideoOnboarding',
    'VideoIdEnpal',
  ],
  'video-id-retry/enpal.partnersales.qes.forJoint': ['VideoIdEnpal'],
  'switch-to-mobile/enpal.partnersales.qes.forJoint': ['SwitchToMobileEnpal'],
  'verifying/enpal.partnersales.qes.forJoint': ['IdentityVerificationEnpal'],
  // enpal.partnersales.ses.withCounterSigning.forJoint
  'videoId/enpal.partnersales.ses.withCounterSigning.forJoint': [
    'GeneralConditions',
    'UserData',
    'SignDocumentEnpal',
    'DocumentTypeEnpal',
    'VideoOnboarding',
    'VideoIdEnpal',
  ],
  'video-id-retry/enpal.partnersales.ses.withCounterSigning.forJoint': ['VideoIdEnpal'],
  'switch-to-mobile/enpal.partnersales.ses.withCounterSigning.forJoint': ['SwitchToMobileEnpal'],
  'verifying/enpal.partnersales.ses.withCounterSigning.forJoint': ['IdentityVerificationEnpal'],
  // enpal.partnersales.ses.forJoint
  'videoId/enpal.partnersales.ses.forJoint': [
    'GeneralConditions',
    'UserData',
    'SignDocumentEnpal',
    'DocumentTypeEnpal',
    'VideoOnboarding',
    'VideoIdEnpal',
  ],
  'video-id-retry/enpal.partnersales.ses.forJoint': ['VideoIdEnpal'],
  'switch-to-mobile/enpal.partnersales.ses.forJoint': ['SwitchToMobileEnpal'],
  'verifying/enpal.partnersales.ses.forJoint': ['IdentityVerificationEnpal'],
  // enpal.buy-in-lease.qes.forJoint
  'videoId/enpal.buy-in-lease.qes.forJoint': [
    'GeneralConditions',
    'UserData',
    'SignDocumentEnpal',
    'DocumentTypeEnpal',
    'VideoOnboarding',
    'VideoIdEnpal',
  ],
  'video-id-retry/enpal.buy-in-lease.qes.forJoint': ['VideoIdEnpal'],
  'switch-to-mobile/enpal.buy-in-lease.qes.forJoint': ['SwitchToMobileEnpal'],
  'verifying/enpal.buy-in-lease.qes.forJoint': ['IdentityVerificationEnpal'],
  // enpal.buy-in-lease.ses.forJoint
  'videoId/enpal.buy-in-lease.ses.forJoint': [
    'GeneralConditions',
    'UserData',
    'SignDocumentEnpal',
    'DocumentTypeEnpal',
    'VideoOnboarding',
    'VideoIdEnpal',
  ],
  'video-id-retry/enpal.buy-in-lease.ses.forJoint': ['VideoIdEnpal'],
  'switch-to-mobile/enpal.buy-in-lease.ses.forJoint': ['SwitchToMobileEnpal'],
  'verifying/enpal.buy-in-lease.ses.forJoint': ['IdentityVerificationEnpal'],
  // enpal.buy-in-lease.ses.counterSign.forJoint
  'videoId/enpal.buy-in-lease.ses.counterSign.forJoint': [
    'GeneralConditions',
    'UserData',
    'SignDocumentEnpal',
    'DocumentTypeEnpal',
    'VideoOnboarding',
    'VideoIdEnpal',
  ],
  'video-id-retry/enpal.buy-in-lease.ses.counterSign.forJoint': ['VideoIdEnpal'],
  'switch-to-mobile/enpal.buy-in-lease.ses.counterSign.forJoint': ['SwitchToMobileEnpal'],
  'verifying/enpal.buy-in-lease.ses.counterSign.forJoint': ['IdentityVerificationEnpal'],
  // enpal.buy-in-lease.ses.withCounterSigning.forJoint
  'videoId/enpal.buy-in-lease.ses.withCounterSigning.forJoint': [
    'GeneralConditions',
    'UserData',
    'SignDocumentEnpal',
    'DocumentTypeEnpal',
    'VideoOnboarding',
    'VideoIdEnpal',
  ],
  'video-id-retry/enpal.buy-in-lease.ses.withCounterSigning.forJoint': ['VideoIdEnpal'],
  'switch-to-mobile/enpal.buy-in-lease.ses.withCounterSigning.forJoint': ['SwitchToMobileEnpal'],
  'verifying/enpal.buy-in-lease.ses.withCounterSigning.forJoint': ['IdentityVerificationEnpal'],
  // enpal.retrofit.qes.forJoint
  'videoId/enpal.retrofit.qes.forJoint': [
    'GeneralConditions',
    'UserData',
    'SignDocumentEnpal',
    'DocumentTypeEnpal',
    'VideoOnboarding',
    'VideoIdEnpal',
  ],
  'video-id-retry/enpal.retrofit.qes.forJoint': ['VideoIdEnpal'],
  'switch-to-mobile/enpal.retrofit.qes.forJoint': ['SwitchToMobileEnpal'],
  'verifying/enpal.retrofit.qes.forJoint': ['IdentityVerificationEnpal'],
  // enpal.retrofit.ses.forJoint
  'videoId/enpal.retrofit.ses.forJoint': [
    'GeneralConditions',
    'UserData',
    'SignDocumentEnpal',
    'DocumentTypeEnpal',
    'VideoOnboarding',
    'VideoIdEnpal',
  ],
  'video-id-retry/enpal.retrofit.ses.forJoint': ['VideoIdEnpal'],
  'switch-to-mobile/enpal.retrofit.ses.forJoint': ['SwitchToMobileEnpal'],
  'verifying/enpal.retrofit.ses.forJoint': ['IdentityVerificationEnpal'],
  // enpal.retrofit.ses.counterSign.forJoint
  'videoId/enpal.retrofit.ses.counterSign.forJoint': [
    'GeneralConditions',
    'UserData',
    'SignDocumentEnpal',
    'DocumentTypeEnpal',
    'VideoOnboarding',
    'VideoIdEnpal',
  ],
  'video-id-retry/enpal.retrofit.ses.counterSign.forJoint': ['VideoIdEnpal'],
  'switch-to-mobile/enpal.retrofit.ses.counterSign.forJoint': ['SwitchToMobileEnpal'],
  'verifying/enpal.retrofit.ses.counterSign.forJoint': ['IdentityVerificationEnpal'],
  // enpal.retrofit.ses.withCounterSigning.forJoint
  'videoId/enpal.retrofit.ses.withCounterSigning.forJoint': [
    'GeneralConditions',
    'UserData',
    'SignDocumentEnpal',
    'DocumentTypeEnpal',
    'VideoOnboarding',
    'VideoIdEnpal',
  ],
  'video-id-retry/enpal.retrofit.ses.withCounterSigning.forJoint': ['VideoIdEnpal'],
  'switch-to-mobile/enpal.retrofit.ses.withCounterSigning.forJoint': ['SwitchToMobileEnpal'],
  'verifying/enpal.retrofit.ses.withCounterSigning.forJoint': ['IdentityVerificationEnpal'],
  // generics enpal
  'verified-single': ['SuccessWithVideoEnpal'],
  // LTQC Issuance Scenarios
  'verified-ltqc': ['LtqcSignVerified'],
  'terms-and-conditions/eidv.ltqcIssuance.test': ['EnrollmentStart', 'TermsAndConditions'],
  'videoId/eidv.ltqcIssuance.test': [
    'GeneralConditions',
    'UserData',
    'DocumentType',
    'VideoOnboarding',
    'EnrollmentVideoId',
    'EnrollmentVerification',
    'EnrollmentAcceptCertificate',
    'EnrollmentCreatePassword',
  ],
  'terms-and-conditions/eidv.ltqcIssuance': ['EnrollmentStart', 'TermsAndConditions'],
  'videoId/eidv.ltqcIssuance': [
    'GeneralConditions',
    'UserData',
    'DocumentType',
    'VideoOnboarding',
    'EnrollmentVideoId',
    'EnrollmentVerification',
    'EnrollmentAcceptCertificate',
    'EnrollmentCreatePassword',
  ],
  // Elavon scenarios
  'eid/elavon.dk.eid.ais': ['EidElavon'],
  'eid/elavon.fi.eid.ais': ['EidElavon'],
  'eid/elavon.no.eid.ais': ['EidElavon'],
  'eid/elavon.se.eid.ais': ['EidElavon'],
  'eid/elavon.dk.eid': ['EidElavon'],
  'eid/elavon.fi.eid': ['EidElavon'],
  'eid/elavon.no.eid': ['EidElavon'],
  'eid/elavon.se.eid': ['EidElavon'],
  'terms-and-conditions/elavon.dk.eid.ais': ['TermsAndConditionsElavon'],
  'terms-and-conditions/elavon.fi.eid.ais': ['TermsAndConditionsElavon'],
  'terms-and-conditions/elavon.no.eid.ais': ['TermsAndConditionsElavon'],
  'terms-and-conditions/elavon.se.eid.ais': ['TermsAndConditionsElavon'],
  'gocardless-sandbox-select/elavon.dk.eid.ais': [
    'GocardlessCheck',
    'GocardlessTransactionDataSelection',
    'GocardlessCustomTransactionData',
    'GocardlessCountry',
    'GocardlessBankSelectionWithButton',
  ],
  'gocardless-sandbox-select/elavon.fi.eid.ais': [
    'GocardlessCheck',
    'GocardlessTransactionDataSelection',
    'GocardlessCustomTransactionData',
    'GocardlessCountry',
    'GocardlessBankSelectionWithButton',
  ],
  'gocardless-sandbox-select/elavon.no.eid.ais': [
    'GocardlessCheck',
    'GocardlessTransactionDataSelection',
    'GocardlessCustomTransactionData',
    'GocardlessCountry',
    'GocardlessBankSelectionWithButton',
  ],
  'gocardless-sandbox-select/elavon.se.eid.ais': [
    'GocardlessCheck',
    'GocardlessTransactionDataSelection',
    'GocardlessCustomTransactionData',
    'GocardlessCountry',
    'GocardlessBankSelectionWithButton',
  ],
  'ais-complete': ['SuccessElavon'],
  'eid-complete': ['SuccessEidElavon'],
  'easy-sign': ['EasySignSmsOtpVerification', 'EasySignDocument', 'EasySignSignature'],
  'easy-sign/enpal.energy.ses.forJoint': [
    'EasySignSmsOtpVerification',
    'EasySignDocument',
    'EasySignHandwrittenSignature',
  ],
  'easy-sign_wait-all-documents-ready-to-display': ['EasySignWaitProceed'],
  'easy-sign_wait-all-documents-signed': ['EasySignWaitComplete'],
  'pending-signatories': ['PendingSignatories'],
  // CMC scenarios
  'eid-complete-cmc': ['SuccessEidCmc'],
  // Onventis scenarios
  'onventis-verification-pending': ['SuccessOnventis'],
  'error-user-sign-rejection': ['SignRejection'],
  'transaction-completed': ['TransactionCompleted'],
  readid: ['ReadId'],
  'readid-completed': ['ReadIdCompleted'],
  // EU Digital Identity Wallet presentation (QR code / deep link); the web-api is the OID4VP relying party
  'wallet-verification': ['WalletVerification'],
  'easy-sign/enpal.lifecycle.ses.noCounterSigning.forJoint': [
    'EasySignSmsOtpVerification',
    'SignDocumentWithStamps',
    'EasySignSignature',
  ],
  // Entry point of the age verification process (passkey auth or redirect to eID)
  'age-verification': ['AgeVerificationStart', 'AgeVerificationStatus'],
  // Return path after the eID (NBID/SBID) verification
  'age-verification-return': ['AgeVerificationRegistration', 'AgeVerificationStatus'],
  // Terminal screen the BE redirects to after completing the transaction
  'age-verification-complete': ['AgeVerificationComplete'],
}
